import {
  Button,
  Checkbox,
  CheckboxGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Text,
} from '@chakra-ui/react'
import { saveAs } from 'file-saver'
import { useState } from 'react'
import XLSX from 'xlsx'
const offerBatchUpdateOptions = [
  {
    label: 'Profit Center',
    value: 'profitCenter',
  },
  {
    label: 'Project Start Date',
    value: 'projectStartDate',
  },
  {
    label: 'Project End Date',
    value: 'projectEndDate',
  },
  {
    label: 'Customer',
    value: 'customer',
  },
  {
    label: 'End Customer',
    value: 'endCustomer',
  },
  {
    label: 'SISIC',
    value: 'sisic',
  },
  {
    label: 'WBS #',
    value: 'wbsNumber',
  },
  {
    label: 'Equipment ID',
    value: 'equipmentId',
  },
]

const CreateOfferBatchUpdateModal = ({ modalDetail, setModalDetail }) => {
  const { show } = modalDetail

  //State
  const [checkedOptions, setCheckedOptions] = useState([])
  const allChecked = checkedOptions.length === offerBatchUpdateOptions.length
  const optionIsIndeterminate = checkedOptions.length > 0 && !allChecked

  const handleModalClose = () => {
    setCheckedOptions([])
    setModalDetail({ show: false })
  }

  const handleCreateTemplate = () => {
    const templateData = ['quotationNumber'].concat(checkedOptions)
    checkedOptions.forEach((option) => {
      templateData[option] = ''
    })

    const workbook = XLSX.utils.book_new()
    const worksheet = XLSX.utils.aoa_to_sheet([templateData])

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

    // Convert the workbook to a blob
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
    const excelBlob = new Blob([new Uint8Array(wbout)], { type: 'application/octet-stream' })

    // Save the blob as a file using FileSaver
    saveAs(excelBlob, 'batch update offer template.xlsx')
    handleModalClose()
  }

  return (
    <Modal isOpen={show} onClose={handleModalClose} size="xl">
      <ModalOverlay />
      <ModalContent mt="3" maxW="75%">
        <ModalHeader>Generate Offer Batch Update template</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Checkbox
            isChecked={allChecked}
            isIndeterminate={optionIsIndeterminate}
            onChange={() => {
              if (allChecked) {
                setCheckedOptions([])
              } else {
                setCheckedOptions(offerBatchUpdateOptions.map((tab) => tab.value))
              }
            }}
          >
            <Text fontWeight={'bold'}>Select All</Text>
          </Checkbox>
          <CheckboxGroup defaultValue={checkedOptions} value={checkedOptions}>
            <SimpleGrid columns={3} spacingX="40px" spacingY="15px" mb="5">
              {offerBatchUpdateOptions.map((option) => (
                <Checkbox
                  key={option?.value}
                  value={option?.value}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setCheckedOptions((prev) => [...prev, option.value])
                    } else {
                      setCheckedOptions((prev) => prev.filter((t) => t !== option.value))
                    }
                  }}
                >
                  {option.label}
                </Checkbox>
              ))}
            </SimpleGrid>
          </CheckboxGroup>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="green" onClick={handleCreateTemplate}>
            Create
          </Button>
          <Button colorScheme="gray" onClick={handleModalClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default CreateOfferBatchUpdateModal
